import { render } from "./RegistrationPrivacyPolicyData.vue?vue&type=template&id=4cc02ed8&scoped=true&ts=true"
import script from "./RegistrationPrivacyPolicyData.vue?vue&type=script&lang=ts"
export * from "./RegistrationPrivacyPolicyData.vue?vue&type=script&lang=ts"

import "./RegistrationPrivacyPolicyData.vue?vue&type=style&index=0&id=4cc02ed8&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc02ed8"]])

export default __exports__